module.exports = __webpack_public_path__ + "img/big_1_55.5b19f010.png";